export default __webpack_public_path__ + "media/images/backgrounds/cream-vegetables-65b853401bdd1599e06dbcbcd848d99c.jpg";